import { useEffect, useState } from "react";
import api, { eur, formatApiErrorDetail } from "@/lib/api";
import { PageHeader, ConfirmDelete } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Trash2, Plus, BookOpen } from "lucide-react";
import { toast } from "sonner";

export default function WorkCatalog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [form, setForm] = useState({ name: "", hours: "", unit_price: "" });

  const load = () => api.get("/work-catalog").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name.trim()) { toast.error("Zadajte názov práce"); return; }
    try {
      await api.post("/work-catalog", { name: form.name.trim(), hours: Number(form.hours) || 0, unit_price: Number(form.unit_price) || 0 });
      toast.success("Práca uložená"); setForm({ name: "", hours: "", unit_price: "" }); load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const remove = async (id) => { await api.delete(`/work-catalog/${id}`); load(); };

  const shown = items.filter((w) => !q.trim() || w.name.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title="Cenník prác" subtitle="Vlastná databáza prác a normohodín – používa ju aj AI pri odhade" />

      <div className="card-surface mb-5 grid gap-3 p-5 sm:grid-cols-[1fr_auto_auto_auto]">
        <div className="space-y-1.5"><Label>Názov práce</Label><Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="napr. Výmena predných bŕzd" data-testid="wc-name" /></div>
        <div className="space-y-1.5"><Label>Hodiny</Label><Input type="number" step="0.1" className="w-24" value={form.hours} onChange={(e) => setForm((f) => ({ ...f, hours: e.target.value }))} data-testid="wc-hours" /></div>
        <div className="space-y-1.5"><Label>Cena/h €</Label><Input type="number" step="0.5" className="w-24" value={form.unit_price} onChange={(e) => setForm((f) => ({ ...f, unit_price: e.target.value }))} data-testid="wc-price" /></div>
        <div className="flex items-end"><Button onClick={add} className="gap-1" data-testid="wc-add"><Plus className="h-4 w-4" /> Pridať</Button></div>
      </div>

      <div className="mb-3"><Input placeholder="Hľadať prácu…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="wc-search" /></div>

      <div className="space-y-2">
        {shown.map((w) => (
          <div key={w.id} className="card-surface flex items-center justify-between gap-3 p-4" data-testid={`wc-row-${w.id}`}>
            <div className="min-w-0">
              <div className="truncate font-heading text-lg font-bold">{w.name}</div>
              <div className="text-sm text-muted-foreground">{w.hours} h{w.unit_price ? ` · ${eur(w.unit_price)}/h` : ""}{w.count > 1 ? ` · použité ${w.count}×` : ""}</div>
            </div>
            <ConfirmDelete onConfirm={() => remove(w.id)} description={`Položka cenníka „${w.name}“ bude odstránená.`}>
              <Button variant="ghost" size="icon" data-testid={`wc-delete-${w.id}`}><Trash2 className="h-4 w-4 text-destructive" /></Button>
            </ConfirmDelete>
          </div>
        ))}
        {!shown.length && (
          <div className="card-surface flex flex-col items-center gap-2 py-12 text-center text-muted-foreground">
            <BookOpen className="h-8 w-8 opacity-40" />
            Zatiaľ žiadne práce. Pridajte ich ručne alebo sa doplnia pri používaní AI výpočtu normohodín.
          </div>
        )}
      </div>
    </div>
  );
}
